import { UserPermission } from '@services/business/identity/entities/cognito-user';
import { ApiInterface, EmptyObject } from '@stetamalo/cloud-platform/catalog/api';
import { Schemy } from '@stetamalo/cloud-platform/lib/schemy';
import { ApiConfig } from 'services/support/utils/types/api-config';

export type Interface = ApiInterface<{
  response: { success: true };
  pathParams: { username: string };
  body: {
    name: string;
    lastName: string;
    password: string;
    permission: UserPermission;
  };
  claims: { tenantId: string; sub: string };
  queryParams: EmptyObject;
}>;

export const config: ApiConfig<Interface> = {
  name: 'api-update-employee',
  method: 'PUT',
  basePath: 'identity',
  path: '/employee/{username}',
  tablePermission: 'readWrite',
  scope: 'ADMIN',
  schema: Schemy.schema<Interface['body']>({
    name: { type: String, required: true },
    lastName: { type: String, required: true },
    password: { type: String, required: true },
    permission: { type: String, enum: ['ADMIN', 'RECEPTIONIST'], required: true },
  }),
};
